var exports = {
  "j": "UpsellBannerOcticon__-1pjIQ",
  "K": "UpsellBannerHeading__IYcbDJ",
};

module.exports = exports;
